import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Gateway SetFilter] Action',
  ResetFilter: '[Gateway ResetFilter] Action',
}

const initialGatewayState: IGatewayState = {
  filter: {
    siteId: '',
    active: true,
  },
}

export interface IGatewayState {
  filter?: {
    siteId: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Gateway', whitelist: ['filter']},
  (state: IGatewayState = initialGatewayState, action: ActionWithPayload<IGatewayState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialGatewayState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}
